import { Role } from '@/router/role-enum';
import { authentication } from '@/modules/authentication/oauth2';

export function isUserSupplier(): boolean {
  const { user } = authentication;
  return !!user && user.memberof.map(group => group.cn).some(role => role === Role.SUPPLIER_USER);
}
